export const HEADER_STICKY_ID = 'HEADER_STICKY_ID';
